// Deutschland
export default {
	appTitle: "base",
	login: "Anmelden",
	register: "Registrieren",
	home: "Zuhause",
	service: "Dienst",
	starting: "Beginnend",
	records: "Aufzeichnungen",
	order: "@:router.starting",
	my: "Mein",
	start: "Start",
	privacyPolicy: "Datenschutzerklärung",
	wheels: "@:wheels:title",
	BonusRules: "Bonusregeln",
	hotSongCharts: "@:home.hotMusicAlbum",
	gifts: "@:gifts.title",
	giftsRecord: "@:gifts.records.title",
	hotMusic: "@:home.hotMusic",
	event: "@:home.service[1]",
	withdraw: "@:home.service[2]",
	deposit: "@:home.service[3]",
	tc: "@:home.service[4]",
	certificate: "@:home.service[5]",
	faqs: "@:home.service[6]",
	about: "@:home.service[7]",
	vip: "@:vip.title",
	transaction: "@:my.MyFinancial.menu[2]",
	profileItem: {
		title: "@:profileItem.title",
		profile: "@:my.MyDetail.menu[0]",
		updatePassword: "@:profileItem.menu[2]",
		updateTransactionPassword: "@:profileItem.menu[3]"
	},
	paymentMethods: "@:paymentMethods.title",
	notice: "@:my.Other.menu[1]",
	registrationAgreement: "@:system.terms",
	customerServices: "@:home.service[0]"
};
